import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconComponent } from '../../shared/components/icon/icon.component';
import { RevealDirective } from '../../shared/directives/reveal.directive';

/**
 * PPC/marketing landing page for buyer-acquisition ad groups — distinct
 * from /shop (the functional browse page it links out to). Public — no
 * guard, no injected auth logic, purely a static campaign page.
 */
@Component({
  selector: 'app-buy',
  standalone: true,
  imports: [RouterLink, IconComponent, RevealDirective],
  templateUrl: './buy.component.html',
})
export class BuyComponent {}
